<template>
  <main class="report__content">
    <form>
      <div class="wrapper">
        <div class="form__row">
          <h4 class="form__row-title">Markery nowotworowe</h4>
        </div>
        <div class="form__row">
          <div class="form__col-1-6">CEA</div>
          <div class="form__col-1-6">
            <input type="text" v-model="findings.presenceOfTumorMarkers.CEA" />
          </div>
        </div>
        <div class="form__row">
          <div class="form__col-1-6">CA 19-9</div>
          <div class="form__col-1-6">
            <input type="text" v-model="findings.presenceOfTumorMarkers.CA199" />
          </div>
        </div>
        <div class="form__row">
          <div class="form__col-1-6">AFP</div>
          <div class="form__col-1-6">
            <input type="text" v-model="findings.presenceOfTumorMarkers.AFP" />
          </div>
        </div>
      </div>
      <hr />
      <div class="wrapper">
        <div class="form__row">
          <h4 class="form__row-title">Wirusowe zapalenie wątroby</h4>
          <div class="form__col-1-3">
            <label>
              <input type="checkbox" v-model="findings.presence.HBsAg"/>
              <div class="checkbox"></div>
              <span>HBsAg</span>
            </label>
          </div>
          <div class="form__col-1-3">
            <label>
              <input type="checkbox" v-model="findings.presence.antiHCV"/>
              <div class="checkbox"></div>
              <span>anty-HCV</span>
            </label>
          </div>
          <div class="form__col-1-3">
            <label>
              <input type="checkbox" v-model="findings.presence.positiveAntiHBC"/>
              <div class="checkbox"></div>
              <span>dodatnie antyHBC</span>
            </label>
          </div>
        </div>
        <div class="form__row form__row--center">
          <a @click="$emit('back', 2)" class="btn btn--blue">Powrót</a>
          <a class="btn" @click="nextPage">Dalej</a>
        </div>
      </div>
    </form>
  </main>
</template>

<script>
export default {
  name: "Findings",
  data() {
    return {
      findings: {
        presenceOfTumorMarkers: {
          CEA: "",
          CA199: "",
          AFP: ""
        },
        presence: {
          HBsAg: false,
          antiHCV: false,
          positiveAntiHBC: false
        }
      }
    };
  },
  methods: {
    nextPage() {
      this.$store.commit('updateFindings', this.findings)
      this.$emit("next", 4);
    }
  }
};
</script>

<style lang="scss">
</style>